/**
 * useReadOnly — true when the dashboard is in read-only mode (lapsed subscription).
 *
 * Consumed by action controls to disable themselves. Defaults to false outside a
 * ReadOnlyProvider so non-dashboard contexts (and tests) are unaffected.
 *
 * ReadOnlyContext lives here (not in ReadOnlyProvider) to match the codebase's
 * AuthContext/useAuthContext convention and keep the provider file a
 * components-only module (react-refresh HMR ergonomics).
 */
import { createContext, useContext } from "react";

/** Read-only flag context. Provided by ReadOnlyProvider; defaults to false. */
export const ReadOnlyContext = createContext(false);

export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}
